/** Formats an ISO timestamp as a locale date, or an em dash when absent/invalid. */
export function formatDate(value?: string | null): string {
  if (!value) return '—';
  const date = new Date(value);
  return isNaN(date.getTime()) ? '—' : date.toLocaleDateString();
}

/** Formats an ISO timestamp as a locale date and time, or an em dash when absent/invalid. */
export function formatDateTime(value?: string | null): string {
  if (!value) return '—';
  const date = new Date(value);
  return isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

/** Formats a Stripe amount in minor units (e.g. cents) as currency, or an em dash when unknown. */
export function formatMinorUnits(amount?: number | null, currency?: string | null): string {
  if (amount == null || !currency) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(amount / 100);
}
